// @ts-nocheck
import {
  Dialog,
  DialogTitle,
  Tabs,
  Tab,
  Box,
  Checkbox,
  InputLabel,
  Typography,
} from "@mui/material";
import { useState } from "react";
import DrawSignaturePad from "./DrawSignaturePad";
import UploadSignature from "./UploadSignature";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import DigitalSignature from "./DigitalSignature";
import styles from "./../contractDetails.module.css";

export default function SignatureModal({
  open,
  onClose,
  setFields,
  addSignature,
}) {
  const [tab, setTab] = useState(0);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          backgroundColor: "black",
          padding: "1rem 2rem",
          border: "1px solid",
          borderColor: getCssVariableHandler({
            variableName: "--primary-pink-hex",
          }),
          borderRadius: "0.5rem",
        },
      }}
    >
      <DialogTitle
        sx={{ fontSize: "1.25rem", width: "100%", textAlign: "center" }}
      >
        Add New Signature
      </DialogTitle>
      <Tabs
        TabScrollButtonProps={{
          style: {
            color: `${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })}`,
          },
        }}
        aria-label="basic tabs example"
        variant="scrollable"
        sx={{
          width: "100%",
          border: "1px solid #D175B6",
          overflow: "hidden",
          display: "inline-flex",
          justifyContent: "space-between",
          borderRadius: "8px",
          "& button": {
            textTransform: "none",
            width: "33.33%",
            color: "#D175B6",
            "&.Mui-selected": {
              backgroundColor: "#D175B6",
            },
            "& span": {
              display: "none",
            },
          },
          "& .MuiTabs-indicator": {
            display: "none",
          },
        }}
        value={tab}
        onChange={(_, newValue) => setTab(newValue)}
      >
        <Tab label="Choose" />
        <Tab label="Draw" />
        <Tab label="Upload" />
      </Tabs>
      <Box p={2}>
        {tab === 0 && (
          <DigitalSignature setFields={setFields} addSignature={addSignature} />
        )}
        {tab === 1 && (
          <DrawSignaturePad setFields={setFields} addSignature={addSignature} />
        )}
        {tab === 2 && (
          <UploadSignature setFields={setFields} addSignature={addSignature} />
        )}
      </Box>
    </Dialog>
  );
}

export const SignatureConsent = ({ isChecked, setIsChecked }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "0.25rem",
        py: "0.25rem",
      }}
    >
      <Checkbox
        sx={{
          padding: "0",
          color: getCssVariableHandler({
            variableName: "--white-rgb",
          }),
          "&.Mui-checked": {
            color: getCssVariableHandler({
              variableName: "--primary-pink-hex",
            }),
            "& svg": {
              fill: getCssVariableHandler({
                variableName: "--primary-pink-hex",
              }),
            },
          },
        }}
        checked={isChecked}
        onChange={(e) => {
          setIsChecked(e?.target?.checked);
        }}
      />
      <Typography>
        By clicking Create, I consent that my signature and initials will serve
        as my legally binding electronic signature on this envelope and related
        contracts.
      </Typography>
    </Box>
  );
};

SignatureConsent.propTypes = {
  isChecked: PropTypes.bool,
  setIsChecked: PropTypes.func,
};

SignatureModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  setFields: PropTypes.func,
  addSignature: PropTypes.func,
};